/**
 * @author xyguo
 * @description 组合报表管理列表
 * @Date 2021/6/18
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
class ReportConfigList extends WizContainer {

  componentName = 'ReportConfigList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '报表名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建人',
        field: 'creator',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '备注',
        field: 'remark',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
     
    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '组合报表信息',
        sheetName: '组合报表信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '组合报表信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        export:this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ReportConfigList);
